import { createFileRoute } from '@tanstack/react-router'
import { NormalizationDetailPage } from '../../../components/NormalizationDetailPage'
import { NORMALIZATION_TABS, type NormalizationTab } from '../../../components/normalizations/tabs'

export const Route = createFileRoute('/$org/normalizations/$uid')({
  component: NormalizationDetailRoute,
  validateSearch: (search: Record<string, unknown>): { tab?: NormalizationTab } => ({
    tab: NORMALIZATION_TABS.find((tab) => tab === search.tab),
  }),
})

function NormalizationDetailRoute() {
  return <NormalizationDetailPage />
}
